import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Montserrat', sans-serif;
    }

    html {
        font-size: 10px;

        @media (max-width: ${({ theme }) => theme.breakPointL}px) {
            font-size: 9.5px;
        }

        @media (max-width: ${({ theme }) => theme.breakPointM}px) {
            font-size: 9px;
        }
    }

    body {
        font-size: 1.6rem;
        background-color: ${({ theme }) => theme.colors.backgroundPrimary};
    }

    img {
        max-width: 100%;
    }

    .mapboxgl-ctrl-logo {
        display: none !important;
    }

    ::selection {
        color: white;
        background-color: ${({ theme }) => theme.colors.textDetails};
    }

    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    ::-webkit-scrollbar-track {
        background: ${({ theme }) => theme.colors.body};
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 12px;
        background: ${({ theme }) => theme.colors.scrollbarThumb};
    }

    ::-webkit-scrollbar-thumb:hover {
        cursor: pointer;
        background: ${({ theme }) => theme.colors.scrollbarThumbHover};
    }

    ol[data-sonner-toaster="true"] li {
        padding: 16px;
    }

    @media only screen and (max-width: #{breakPointL + 'px'}) {
        html {
            font-size: 9.5px;
        }
    }

    @media only screen and (max-width: #{breakPointM + 'px'}) {
        html {
            font-size: 9px;
        }
    }

    div.ag-theme-alpine div.ag-row {
        font-size: 12px !important;
    }

    .ag-root-wrapper {
        border: none !important;
        border-radius: 0 !important;
    }

    .ag-theme-alpine .ag-row-hover {
        background-color: #EDEEF3 !important;
    }

    .modal-date-picker {
        width: 200px;
    }

    .modal-pull-date-picker {
        width: 220px;
    }

    .pipeline-health-date-picker {
        width: 100%;
    }

    .react-datepicker-popper {
        z-index: 9999 !important;
    }

    .react-datepicker__year-select {
        background: transparent !important;
        color: white !important;
        border: none !important;
        margin-bottom: 8px !important;
    }

    .react-datepicker__day--highlighted {
        background-color: #ffbd9fff!important;
        color: black !important;
        border: solid 1.5px #EC6728!important;
    }

    .react-datepicker__year-select option {
        color: black !important;
        background-color: white !important;
    }

`;
